// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a47ce104","455":"bbea6ccf","977":"240addac"}[chunkId] + ".chunk.js";
};